import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../api/api";
import "./Cart.css";
import Layout from '../components/Layout';

const Cart = () => {
    const [cartItems, setCartItems] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);

    useEffect(() => {
        const fetchCart = async () => {
            try {
                const response = await axios.get("/carts");
                setCartItems(response.data.items);
                setTotalPrice(response.data.totalPrice);
            } catch (error) {
                console.error("Error fetching cart:", error);
            }
        };

        fetchCart();
    }, []);

    const handleQuantityChange = async (productId, newQuantity) => {
        if (newQuantity < 1) return; // Không cho số lượng nhỏ hơn 1
    
        try {
            const response = await axios.put(`/carts/update/${productId}`, {
                quantity: newQuantity,
            });
    
            // Đảm bảo dữ liệu trả về đúng định dạng
            const { items, totalPrice } = response.data || {};
            if (items && Array.isArray(items)) {
                setCartItems(items);
                setTotalPrice(totalPrice || 0);
            } else {
                console.error("Invalid response format:", response.data);
            }
        } catch (error) {
            console.error("Error updating quantity:", error);
        }
    };
    

    const handleRemoveItem = async (productId) => {
        try {
            const response = await axios.delete(`/carts/remove/${productId}`);
    
            // Đảm bảo dữ liệu trả về đúng định dạng
            const { items, totalPrice } = response.data || {};
            if (items && Array.isArray(items)) {
                setCartItems(items);
                setTotalPrice(totalPrice || 0);
            } else {
                console.error("Invalid response format:", response.data);
            }
        } catch (error) {
            console.error("Error removing item:", error);
        }
    };
    

    return (
        <Layout>
            <div className="cart-container">
                <h1>Giỏ Hàng Của Bạn</h1>
                {cartItems.length === 0 ? (
                    <p>Giỏ hàng của bạn hiện đang trống.</p>
                ) : (
                    <div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Sản phẩm</th>
                                    <th>Giá</th>
                                    <th>Số lượng</th>
                                    <th>Thành tiền</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {cartItems.map((item) => (
                                    <tr key={item.productId}>
                                        <td>{item.productName}</td>
                                        <td>{item.price.toLocaleString()} VND</td>
                                        <td>
                                            <input
                                                type="number"
                                                min="1"
                                                value={item.quantity}
                                                onChange={(e) =>
                                                    handleQuantityChange(item.productId, parseInt(e.target.value))
                                                }
                                                className="form-control quantity-input"
                                            />
                                        </td>
                                        <td>{(item.price * item.quantity).toLocaleString()} VND</td>
                                        <td>
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleRemoveItem(item.productId)}
                                            >
                                                Xóa
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="cart-summary">
                            <h4>Tổng Tiền: {totalPrice.toLocaleString()} VND</h4>
                        </div>
                        <div className="cart-actions">
                            <Link to="/products" className="btn btn-secondary">
                                Tiếp Tục Mua Hàng
                            </Link>
                            <Link to="/checkout" className="btn btn-primary">
                                Thanh Toán
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default Cart;
